import r from"react";import e from"../Icon/Icon.js";var o=function(){return r.createElement(e,{name:"general.dragHandle",size:"sm",color:"foregroundTertiary",cursor:"grab"})};export{o as default};
//# sourceMappingURL=DragHandle.js.map
